import styled from 'styled-components';
import { layout } from 'styles/layout';

export const PricingBannersContainer = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const pricingBannersDesktopBreakpoint = layout.md;

export const SliderWrapper = styled.div`
  display: block;
  position: relative;

  @media all and (min-width: ${pricingBannersDesktopBreakpoint}) {
    display: none;
  }

  .slick-dots {
    top: -38px;
    height: 34px;

    li {
      margin: 0 8px;
      button {
        &:before {
          font-size: 14px;
        }
      }
    }
  }

  .slick-prev {
    z-index: 1;
    left: 0;
  }

  .slick-next {
    right: 0;
  }
`;

export const DesktopWrapper = styled.div`
  display: none;
  align-items: center;
  max-width: 1342px;
  width: 100%;
  margin: 0 auto;

  & > div {
    &:first-child {
      order: 1;
      box-shadow: 0 3px 7px #ecebe8;
      background-color: #fafaf9;
      z-index: 1;
    }

    &:nth-child(2) {
      order: 0;
      transform: translateX(5%);
    }

    &:nth-child(3) {
      order: 2;
      transform: translateX(-5%);
    }
  }

  @media all and (min-width: ${pricingBannersDesktopBreakpoint}) {
    display: flex;
  }
`;